module.exports = __webpack_public_path__ + "static/media/3DPPA39.f2d6b009.jpg";